import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RentalsService } from "../../../../../../services/rentals.service";
import { HelpersService } from "../../../../../../services/helpers.service";
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-rental-service-indicator-config-sidebar',
  templateUrl: './rental-service-indicator-config-sidebar.component.html',
  styleUrls: ['./rental-service-indicator-config-sidebar.component.scss']
})
export class RentalServiceIndicatorConfigSidebarComponent {
  @Input() serviceIndicatorConfig: any;
  @Input() rentalConfig: any;
  @Input() serviceIndicatorModes: any;

  @Input() metricOptions: any;
  @Output() onClose = new EventEmitter();


  showBasicExpanded: boolean = false;
  showAdvancedExpanded: boolean = false;
  activeIndex: number = 0;
  saving: boolean = false;
  partnerData: any = null;
  productCategories: any = [];
  loadingProductCategories: boolean = false;

  constructor(
    public translate: TranslateService,
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    if (!this.serviceIndicatorConfig) {
      this.serviceIndicatorConfig = {
        defaultPartnerID: this.helpersService.getPartnerId(),
        mode: 'basic',
        serviceIndicatorName: '',
        isActive: true,
        defaultIndicator: false,
        linkedCategories: [],
        basicIndicator: this.getDefaultBasicIndicator(),
        advancedIndicators: []
      }
    }

    // Existing configs come from the API, which returns either basicIndicator OR
    // advancedIndicators as null depending on the saved mode (the other side is
    // `CASE ... ELSE NULL` in SQL). Normalise both sides so switching mode never
    // dereferences null in isValid()/addIndicator()/getMetricOptions() or the template.
    this.normaliseServiceIndicatorConfig();

    this.getLinkedProoductCategories();
  }

  private getDefaultBasicIndicator() {
    return {
      metric: 'Points',
      maxPoints: 100,
      pointsPerRentalPerHour: 2,
      pointsPerRentalPerDay: 10,
      idleDecay: 1,
      deactivateProductWhenServiceRequired: false
    };
  }

  private normaliseServiceIndicatorConfig() {
    if (!this.serviceIndicatorConfig.basicIndicator) {
      this.serviceIndicatorConfig.basicIndicator = this.getDefaultBasicIndicator();
    }
    if (!this.serviceIndicatorConfig.advancedIndicators) {
      this.serviceIndicatorConfig.advancedIndicators = [];
    }
    if (!this.serviceIndicatorConfig.linkedCategories) {
      this.serviceIndicatorConfig.linkedCategories = [];
    }
  }

  getLinkedProoductCategories() {
    this.loadingProductCategories = true;
    this.rentalsService.getProductCategoriesLinkedToServiceIndicators(this.serviceIndicatorConfig.defaultPartnerID, this.serviceIndicatorConfig.id || 0).subscribe((response: any) => {
      this.productCategories = response.filter(x => { return !x.linkedToServiceIndicator });
      this.loadingProductCategories = false;
    });
  }

  addIndicator() {
    var firstindicator = this.getMetricOptions(null).pop();
    const newIndicator = {
      component: '',
      metric: this.serviceIndicatorConfig.advancedIndicators && this.serviceIndicatorConfig.advancedIndicators.length === 0 ? 'Points' : firstindicator ? firstindicator.value : '',
      maxPoints: 100,
      pointsPerRentalPerHour: 2,
      pointsPerRentalPerDay: 10,
      idleDecay: 1,
      threshold: null,
      action: '',
      deactivateProductWhenServiceRequired: false
    };

    if (this.serviceIndicatorConfig.advancedIndicators === null) {
      this.serviceIndicatorConfig.advancedIndicators = [];
    }
    this.serviceIndicatorConfig.advancedIndicators.push(newIndicator);
    this.activeIndex = this.serviceIndicatorConfig.advancedIndicators.length - 1;

  }

  removeIndicator(index: number) {
    if (this.serviceIndicatorConfig.id) {
      this.confirmationService.confirm({
        //key: 'quote-option',
        rejectVisible: true,
        acceptLabel: this.translate.instant('general.yes'),
        rejectLabel: this.translate.instant('general.cancel'),
        header: this.translate.instant(
          'bikeshop.rentals.service_indicators_config.delete_component_header',
        ),
        message: this.translate.instant(
          'bikeshop.rentals.service_indicators_config.delete_component_message',
        ),
        accept: () => {
          this.serviceIndicatorConfig.advancedIndicators.splice(index, 1);
        },
      });
    } else {
      this.serviceIndicatorConfig.advancedIndicators.splice(index, 1);
    }


  }

  saveServiceIndicator() {
    this.saving = true;
    this.rentalsService.updateRenalServiceIndicator(this.serviceIndicatorConfig).subscribe((response: any) => {
      this.rentalConfig = response;
      this.saving = false;
      this.onClose.emit();
    }, err => {
      this.saving = false;
    });
  }

  cancel() {
    this.onClose.emit();
  }

  isValid() {

    var isBasicValid = this.serviceIndicatorConfig.mode === 'basic' && this.serviceIndicatorConfig.basicIndicator.metric === 'Points' ?
      this.serviceIndicatorConfig.basicIndicator.maxPoints > 0
      && this.serviceIndicatorConfig.basicIndicator.pointsPerRentalPerHour >= 0
      && this.serviceIndicatorConfig.basicIndicator.pointsPerRentalPerDay >= 0
      && this.serviceIndicatorConfig.basicIndicator.idleDecay >= 0 :
      this.serviceIndicatorConfig.mode === 'basic' && this.serviceIndicatorConfig.basicIndicator.metric !== 'Points' ?
        this.serviceIndicatorConfig.basicIndicator.threshold > 0 : true

    var isAdvancedValid = true;
    if (this.serviceIndicatorConfig.mode === 'advanced') {
      if (this.serviceIndicatorConfig.advancedIndicators.length === 0) {
        isAdvancedValid = false;
      }
      if (this.serviceIndicatorConfig.advancedIndicators.length > 0) {
        this.serviceIndicatorConfig.advancedIndicators.forEach((indicator: any) => {
          if (indicator.metric === 'Points' && !(indicator.maxPoints > 0 && indicator.pointsPerRentalPerHour >= 0 && indicator.pointsPerRentalPerDay >= 0 && indicator.idleDecay >= 0)) {
            isAdvancedValid = false;
          } else if (indicator.metric !== 'Points' && !(indicator.threshold > 0)) {
            isAdvancedValid = false;
          }

          if (!indicator.action || indicator.action.length === 0 || !indicator.component || indicator.component.length === 0) {
            isAdvancedValid = false;
          }
        });
      }
    }


    return this.serviceIndicatorConfig.serviceIndicatorName && this.serviceIndicatorConfig.serviceIndicatorName.length > 0 &&
      //(!this.serviceIndicatorConfig.isActive || (this.serviceIndicatorConfig.isActive && this.serviceIndicatorConfig.linkedCategories.length > 0)) &&
      isBasicValid && isAdvancedValid;
  }

  onKeyPress(event: KeyboardEvent) {
    // Only allow numbers, backspace, delete, tab, escape, enter
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    if (allowedKeys.includes(event.key) ||
      (event.key >= '0' && event.key <= '9')) {
      return;
    }
    event.preventDefault();
  }

  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  getMetricOptions(indicator: any) {
    var metricOptions = this.metricOptions.filter((option: any) => {
      return !this.serviceIndicatorConfig.advancedIndicators.some((ind: any) => ind.metric === option.value);
    });
    console.log('metricOptions', metricOptions);
    if (indicator && indicator.metric) {
      metricOptions.push(this.metricOptions.find((option: any) => option.value === indicator.metric));
    }
    console.log('metricOptions', metricOptions);
    return metricOptions.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      } else if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  }

}
